import usePosTakeout from "@/shared/atoms/usePosTakeout";
import useCommon from "@/shared/hooks/useCommon";
import IconButton from "../IconButton/IconButton";
import { useEffect } from "react";

const PosTakeoutButton = () => {
  const [takeout, setTakeout] = usePosTakeout();
  const t = useCommon();

  useEffect(() => {
    return () => setTakeout(false);
  }, [setTakeout]);

  return (
    <div className="relative">
      <div
        onClick={() => setTakeout(!takeout)}
        className="flex cursor-pointer gap-1 px-1 items-center rounded-3xl shadow-sm bg-grey"
      >
        <IconButton
          variants="utensils"
          size="small"
          variant={takeout ? "secondary" : "primary"}
        />
        <IconButton
          variants="basket"
          size="small"
          variant={takeout ? "primary" : "secondary"}
        />
      </div>

      <div
        className="absolute left-1/2 bottom-[-1.75rem] whitespace-nowrap text-btn-small font-bold"
        style={{
          transform: "translateX(-50%)",
          color: "var(--text)",
          fontWeight: 900,
          zIndex: 999,
        }}
      >
        {t(takeout ? "pickup" : "dineIn")}
      </div>
      {/* <BooleanWithLabel
        onChange={(e) => {
          setTakeout(e.target.checked);
        }}
        checked={takeout}
      >
        <div>{t("takeout")}</div>
      </BooleanWithLabel> */}
    </div>
  );
};

export default PosTakeoutButton;
